import workspaceQuery from '../../../graphql/queries/sales/ImportedWooCommerceOrderWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/ImportedWooCommerceOrderListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/ImportedWooCommerceOrderQuery.graphql';
import mutationQuery from '../../../graphql/mutations/sales/ImportedWooCommerceOrderMutation.graphql';
import fragment from '../../../graphql/fragments/sales/ImportedWooCommerceOrderFragment.graphql';
import aggregateQuery from '../../../graphql/queries/sales/ImportedWooCommerceOrderAggregateQuery.graphql';

import { workspace } from '../../../actions/sales/ImportedWooCommerceOrderAction';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const ImportedWooCommerceOrder: EntityType = {
  type: 'ImportedWooCommerceOrder',
  title: 'WooCommerce Orders',
  formTitle: 'Imported WooCommerce Order',
  workspaceUrl: '/Sales/Channel/ImportedWooCommerceOrder/Workspace/',
  formUrl: '/Sales/Channel/ImportedWooCommerceOrder/Details/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'orderReference',
  },
  fragment,
  aggregate: aggregateQuery,
  screenReference: 'IMPORTED_WOOCOMMERCE_ORDERS',
  actions: workspace,
  operations: ALLOW_VIEW,
};

export default ImportedWooCommerceOrder;
